import React from 'react';
import { ContextApi } from "../context/ContextApi"


 
const timeStyle={ color: "#8899a6",fontSize: "12px" }



const Time = ()=>{
      return(
          <React.Fragment>
              <ContextApi.Consumer>
              {(context)=>(
            <span style={timeStyle}>{context.state.time}. 1 min Read</span>
              )}
          </ContextApi.Consumer>
          </React.Fragment>
      )
}


export default Time;


// WEBPACK FOOTER //
// ./src/components/mainpage/Time.js